// extracted by mini-css-extract-plugin
module.exports = {"filters":"AuthorBookListView__filters"};